"use strict";

var $ = require("jquery");

$(document).ready(function () {

    $('#checkout-shipping-options .buttons').before($('#e_deliverydate_field'));
});